import { PosBusinessTermsAndConditionsService } from '@app/pos-channels/pos-business-tc/pos-business-tc.service';
import { Component, OnInit, Optional, inject } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '@mpt-fo/common/core/services/general.service';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { LocalStorageService } from '@mpt-fo/common/core/services/local-storage.service';
import { StorageKeys } from '@mpt-fo/common/shared/models/storage-keys';

@Component({
    selector: 'app-business-terms-and-conditions-modal',
    templateUrl: './business-terms-and-conditions-modal.component.html',
    styleUrls: ['./business-terms-and-conditions-modal.component.scss'],
})
export class BusinessTermsAndConditionsModalComponent implements OnInit {
    accept = false;
    isSubmitting = false;
    errorMessage: string;
    isGracePeriodExpired = false;
    businessName: string;

    readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

    constructor(
        @Optional() public modal: NzModalRef,
        private generalService: GeneralService,
        private localStorage: LocalStorageService,
        private router: Router,
        private posBusinessTermsAndConditionsService: PosBusinessTermsAndConditionsService,
    ) {}

    ngOnInit(): void {
        this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
        this.businessName = this.localStorage.get(StorageKeys.businessName);
        this.isGracePeriodExpired = this.modal?.componentInstance.data?.isGracePeriodExpired;
    }

    backToLogin() {
        this.posBusinessTermsAndConditionsService.isModalShowedOnce = false;
        this.posBusinessTermsAndConditionsService.isGracePeriodExpired = false;
        this.generalService.logout();
        this.modal.componentInstance.callback();
        this.modal.destroy();
    }

    close() {
        this.posBusinessTermsAndConditionsService.isModalShowedOnce = false;
        this.modal.destroy();
    }

    navigateToTermsAndConditionsDetails() {
        this.modal.destroy();
        this.posBusinessTermsAndConditionsService.isModalShowedOnce = true;
        let documentId = this.posBusinessTermsAndConditionsService.documentId;
        this.router.navigate([`main-app/business-user/pos-terms-conditions/${documentId}`]);
    }
}
